module.exports = __webpack_public_path__ + "static/media/EGG.1c9772cd.png";